module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_04_sp-fdc05e71ca97d22b12fab2f15be89c7b.png";